module.exports = __webpack_public_path__ + "assets/img/02.d0711646.png";